import React, { Component } from 'react';

export default class HubspotForm extends Component {
  componentDidMount() {
    const hubspotId = '5258344';
    const script = document.createElement('script');

    script.src = 'https://js.hsforms.net/forms/v2.js';
    script.onload = () => {
      window.hbspt.forms.create({
        portalId: hubspotId,
        formId: this.props.formId,
        target: `#hubspotForm`,
      });
    };
    script.onerror = () => {
      console.error('Hubspot form script failed to load');
    };

    document.body.appendChild(script);
  }

  render() {
    return <div id='hubspotForm' />;
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/hubspotForm/index.js
 **/